import Filter from '../Filter';
import Sort from '../Sort';
import {getPaginatedAdmins} from '../../api/admin/AdminApi';

export default class AdminFilter extends Filter {
  constructor(data) {
    super(data);

    this.name = data?.name;
    this.email = data?.email;
    this.status = data?.status;

    this.sorts = {
      name: data?.sorts?.name ?? new Sort(),
      email: data?.sorts?.email ?? new Sort(),
      status: data?.sorts?.status ?? new Sort(),
    }
  }

  get key() {
    return 'admins';
  }

  get paginatedFetcher() {
    return async () => await getPaginatedAdmins(this);
  }
}
